import { Box, Typography, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { NotificationFullData } from "../../layout/UserNotification";
import useThemeStore from "../../services/store/useThemeStore";
import { contentStyles, titleStyles, wrapperStyles } from "./BookingStarted";
import { DateNTime } from "../../utils/dateTime";
import { useTranslation } from "react-i18next";

export const descriptionStyles = (darkMode: boolean) => ({
  font: "var(--body-xs)",
  color: darkMode ? "var(--neutral-300)" : "var(--neutral-500)",
  lineHeight: 1.5,
  fontWeight: 400,
});

interface BookingCreatedProps {
  notification: NotificationFullData;
  closePopover?: () => void;
}

const BookingCreated = ({
  notification,
  closePopover,
}: BookingCreatedProps) => {
  const navigate = useNavigate();
  const { darkMode } = useThemeStore();
  const { t } = useTranslation();
  return (
    <Box onClick={() => navigate("/bookings")} sx={wrapperStyles(darkMode)}>
      <Stack direction="row" spacing={2} alignItems="center" sx={{ flex: 1 }}>
        <Box sx={contentStyles}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Typography sx={titleStyles(darkMode)}>
              {t("booking_request", { ns: "notification" })}
            </Typography>
          </Box>
          <Typography sx={descriptionStyles(darkMode)}>
            {t("you_got_a_new_booking_request", { ns: "notification" })}
          </Typography>
          {notification?.created_at && (
            <Typography
              sx={{
                font: "var(--semibold-xxs)",
                color: darkMode ? "#9ca3af" : "#64748b",
                fontWeight: 500,
              }}
            >
              {DateNTime.formatRelative(notification.created_at)}
            </Typography>
          )}
        </Box>
      </Stack>
    </Box>
  );
};

export default BookingCreated;
